import { render, staticRenderFns } from "./NLS.vue?vue&type=template&id=a5778496&"
import script from "./NLS.vue?vue&type=script&lang=js&"
export * from "./NLS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports